import { Language } from '@/domain/models/account/language/language-enum'
import { i18nTranslationHelper } from '@/i18n'
import { FieldValues } from 'react-hook-form'
import SelectField, { SelectFieldOptionType, SelectFieldProps } from '../select-field/select-field'

function generateLanguageOptions(): SelectFieldOptionType<string>[] {
  return Language.values().map(language => ({
    value: language.code,
    label: language.label
  }))
}

type LanguageFieldProps<T extends FieldValues> = Omit<SelectFieldProps<T, string>, 'label'> & {
  label?: string
}

const t = {
  fields: i18nTranslationHelper.getTEntitiesFields,
  components: i18nTranslationHelper.getTComponents
}

export default function LanguageField<T extends FieldValues>({
  label = t.fields('languageId.label'),
  displayEmpty = true,
  emptyLabel = t.components('select.emptyLabel'),
  ...props
}: LanguageFieldProps<T>) {
  return (
    <SelectField
      label={label}
      displayEmpty={displayEmpty}
      emptyLabel={emptyLabel}
      options={generateLanguageOptions()}
      {...props}
    />
  )
}
